import React from 'react';
import { shortSaleTxt } from "@/setting";
import { trackButtonClick } from '@/utils/analytics';

const ShortSales = ({label}) => {
  return (
    <div className="pdpGenericContainer mb30">
      <div className="container">
        <div className="">
          <h4 className="propertyInfoBoxHeadingText p0">Short Sale</h4>
          <p className="pdpTextBlack">{label} {" "}
            <a
              className='text-decoration-underline learnMoreLink '
              style={{fontSize:16}}
              href={"https://www.hubzu.com/short-sale"}
              target="_blank"
               onClick={() => {
                trackButtonClick({
                  eventName: "learn_more_short_sales",
                  eventCategory: "NEW-PDP",
                  eventSource: "on learn more click",
                });
              }}
            >
              Learn more
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShortSales;